// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KqUQ","colMin":"styles_colMin__12txY"};